import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../api/contests';

const useContestName = (contestId: string | undefined) => {
  const [contestName, setContestName] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!contestId) return;
    const fetchContestName = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/contests/${contestId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch contest name');
        }
        const data = await response.json();
        setContestName(data.name); // Assuming the field is 'name'
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchContestName();
  }, [contestId]);

  return { contestName, loading, error };
};

export default useContestName;
